// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  position: relative;
}

::ng-deep .popover {
  width: 100%;
  max-width: 100%;
  background: none;
  border: none;
  border-radius: 0;
}
::ng-deep .popover .arrow {
  display: none !important;
}
::ng-deep .popover-body {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/demographics/demographics.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/demographics/demographics.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,kBAAA;ACAF;;ADGE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;ACAJ;ADCI;EACE,wBAAA;ACCN;ADCI;EACE,UAAA;ACCN","sourcesContent":["\r\n:host {\r\n  display: block;\r\n  position: relative;\r\n}\r\n::ng-deep {\r\n  .popover {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    background: none;\r\n    border: none;\r\n    border-radius: 0;\r\n    .arrow {\r\n      display: none !important;\r\n    }\r\n    &-body {\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n",":host {\n  display: block;\n  position: relative;\n}\n\n::ng-deep .popover {\n  width: 100%;\n  max-width: 100%;\n  background: none;\n  border: none;\n  border-radius: 0;\n}\n::ng-deep .popover .arrow {\n  display: none !important;\n}\n::ng-deep .popover-body {\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
